class VerifyCodeRequest {

    getRequestVerifyCode = (datosVerificacion) => {
        return {
            "datos": {
                "id": datosVerificacion.id,
                "otp": datosVerificacion.otp
            }
        };
    }
}

export default VerifyCodeRequest;